import { GET_CUSTOMIZE_ORDER_FOR_ADMIN, GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR, GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS } from "./actionTypes"

export const getCustomizeOrderForAdmin = (page_name) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER_FOR_ADMIN,
            payload: page_name
        }
    )
}

export const getCustomizeOrderForAdminSuccess = (columns_order) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS,
            payload: columns_order
        }
    )
}

export const getCustomizeOrderForAdminError = (error) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR,
            payload: error
        }
    )
}


export const updateCustomizeOrderForAdmin = (columns_order) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN,
            payload: columns_order
        }
    )
}

export const updateCustomizeOrderForAdminSuccess = (columns_order, component) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS,
            payload: columns_order,
            component: component
        }
    )
}

export const updateCustomizeOrderForAdminError = (error) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR,
            payload: error
        }
    )

}